import { type ReactNode } from 'react';
import { type QuizTypeOption } from '@/api/ai/useBuildAiQuiz';
import { AiGeneratingPending } from '@/views/build/modal/BuildAiModal/components/AiGeneratingPending';
import { type AttachmentState } from '../hooks/types';
export const getPendingFallback = (attachmentState: AttachmentState, query: string, quizType: QuizTypeOption, hasStandard: boolean): ReactNode => {
  const loadingState = {
    quizType,
    hasStandard
  };
  switch (attachmentState.type) {
    case 'file':
      return <AiGeneratingPending.ByFile file={attachmentState.data} loadingState={loadingState} />;
    case 'youtube':
      return <AiGeneratingPending.ByYoutube youtubeData={attachmentState.data} loadingState={loadingState} />;
    case 'website':
      return <AiGeneratingPending.ByWebsite websiteData={attachmentState.data} loadingState={loadingState} />;
    case 'none':
      return <AiGeneratingPending.ByQuery query={query} loadingState={loadingState} />;
  }
};